import { useNavigate } from "react-router-dom";
import { IconButton, TableCell, TableRow } from "@mui/material";
import CopyButton from "./CopyButton";

function InventorySellerRow(props) {
  const { assignment, columns, color, rowIndex } = props;

  const navigate = useNavigate();

  function handleDetailsClick(event) {
    event.preventDefault();
    localStorage.setItem("productDetailUrl", assignment.picture_url);
    navigate(`/home/inventory-details/${assignment.id}`);
  }

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((column, index) => {
          return (
            <TableCell
              component="th"
              scope="row"
              key={`${column.columnName}-${index}`}
            >
              {
                // column.dbName === "name_sku" ? `${assignment.name} ${assignment.sku}` :
                column.dbName === "name_sku_picture" ? (
                  <div className="product-container">
                    <div
                      className="product-image-container"
                      style={{ marginRight: "20px" }}
                    >
                      <img
                        className="product-image"
                        alt="product image"
                        src={assignment.picture_url}
                      ></img>
                    </div>
                    <div className="copy-button-inventory-seller">
                      {assignment.name}
                      <CopyButton
                        textToCopy={assignment.sku}
                        labelName={"SKU: "}
                        uniqueId={rowIndex}
                      />
                    </div>
                  </div>
                ) : // column.dbName === "name" ? assignment.name :
                column.dbName === "ideal-stock" ? (
                  <div style={{ paddingLeft: "13px" }}>
                    {assignment.ideal_stock}
                  </div>
                ) : column.dbName === "details" ? (
                  <IconButton onClick={handleDetailsClick}>
                    {" "}
                    <i className="material-icons">add</i>
                  </IconButton>
                ) : (
                  "COLUMNA DESCONOCIDA"
                )
              }
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}

export default InventorySellerRow;
